(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52958);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validate */
/* harmony import */ var wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17481);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7258);








yup__WEBPACK_IMPORTED_MODULE_1__.setLocale({
    mixed: {
        required: wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_0__/* ["default"].required_field.message */ .Z.required_field.message,
        notType: wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_0__/* ["default"].required_field.message */ .Z.required_field.message
    },
    number: {
        positive: wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_0__/* ["default"].positive_number.message */ .Z.positive_number.message
    },
    boolean: {
        isValue: wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_0__/* ["default"].checked_field.message */ .Z.checked_field.message
    },
    string: {
        email: wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_0__/* ["default"].email_must_be_valid.message */ .Z.email_must_be_valid.message,
        min: wordings_and_errors_errors_messages__WEBPACK_IMPORTED_MODULE_0__/* ["default"].password_min_length.message */ .Z.password_min_length.message
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (yup__WEBPACK_IMPORTED_MODULE_1__);
function validate(validationSchema, value) {
    return _validate.apply(this, arguments);
}
function _validate() {
    _validate = _async_to_generator(function(validationSchema, value) {
        var fields, error, errors;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        validationSchema.validate(value, {
                            abortEarly: false
                        })
                    ];
                case 1:
                    fields = _state.sent();
                    return [
                        2,
                        {
                            fields: fields
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    if (_instanceof(error, yup.ValidationError)) {
                        if (error.inner.length > 0) {
                            errors = error.inner.reduce(function(errors, error) {
                                return _object_spread_props(_object_spread({}, errors), _define_property({}, error.path || error.name, {
                                    message: error.message
                                }));
                            }, {});
                            return [
                                2,
                                {
                                    errors: errors
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                errors: _define_property({}, error.path || error.name, {
                                    message: error.message
                                })
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            errors: error
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _validate.apply(this, arguments);
}


/***/ }),

/***/ 52958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/LockClosedIcon.js


function LockClosedIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
  }));
}

const ForwardRef = react.forwardRef(LockClosedIcon);
/* harmony default export */ var esm_LockClosedIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/GlobeAltIcon.js


function GlobeAltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
  }));
}

const GlobeAltIcon_ForwardRef = react.forwardRef(GlobeAltIcon);
/* harmony default export */ var esm_GlobeAltIcon = (GlobeAltIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/CodeIcon.js


function CodeIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
  }));
}

const CodeIcon_ForwardRef = react.forwardRef(CodeIcon);
/* harmony default export */ var esm_CodeIcon = (CodeIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/LightningBoltIcon.js


function LightningBoltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  }));
}

const LightningBoltIcon_ForwardRef = react.forwardRef(LightningBoltIcon);
/* harmony default export */ var esm_LightningBoltIcon = (LightningBoltIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/ScaleIcon.js


function ScaleIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
  }));
}

const ScaleIcon_ForwardRef = react.forwardRef(ScaleIcon);
/* harmony default export */ var esm_ScaleIcon = (ScaleIcon_ForwardRef);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./components/Layout/Alerts.tsx + 1 modules
var Alerts = __webpack_require__(45874);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/LinkedinIcon.tsx



var LinkedinIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-linkedin"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: 4,
                cy: 4,
                r: 2
            })
        ]
    }));
};
/* harmony default export */ var components_LinkedinIcon = (LinkedinIcon);

;// CONCATENATED MODULE: ./components/TwitterIcon.tsx



var TwitterIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-twitter"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
        })
    }));
};
/* harmony default export */ var components_TwitterIcon = (TwitterIcon);

;// CONCATENATED MODULE: ./components/YoutubeIcon.tsx



var YoutubeIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-youtube"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m9.75 15.02 5.75-3.27-5.75-3.27v6.54z",
                strokeWidth: "0",
                stroke: "white",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ var components_YoutubeIcon = (YoutubeIcon);

// EXTERNAL MODULE: ./components/shared/Button.tsx
var Button = __webpack_require__(22692);
// EXTERNAL MODULE: ./components/shared/FormInput.jsx
var FormInput = __webpack_require__(86232);
// EXTERNAL MODULE: ./lib/yup.ts
var lib_yup = __webpack_require__(6716);
;// CONCATENATED MODULE: ./domain/newsletter/validation.ts

var subscribeNewsletterValidator = lib_yup/* default.object */.Z.object({
    email: lib_yup/* default.string */.Z.string().trim().email().required()
});

// EXTERNAL MODULE: ./lib/api.ts
var api = __webpack_require__(74390);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/lib/tw-merge.mjs + 10 modules
var tw_merge = __webpack_require__(57851);
;// CONCATENATED MODULE: ./pages/index.tsx




















var container = "max-w-screen-2xl mx-auto lg:px-28";
var __N_SSG = true;
function Home(param) {
    var _data = param.data, features = _data.features, socialLinks = _data.socialLinks;
    var ref = (0,react.useState)(), subscribeObject = ref[0], setSubscribeObject = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)({
        shouldFocusError: false,
        resolver: (0,yup/* yupResolver */.X)(subscribeNewsletterValidator),
        defaultValues: {
            email: ""
        }
    }), register = ref1.register, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, handleSubmit = ref1.handleSubmit;
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(props) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            api/* api.post */.h.post("/newsletter", (0,_object_spread/* default */.Z)({}, props))
                        ];
                    case 1:
                        error = _state.sent().error;
                        if (error) {
                            setSubscribeObject({
                                message: error.message,
                                type: "error"
                            });
                        } else {
                            setSubscribeObject({
                                message: "Congratulations! You're now subscribed to our newsletter. Thank you for joining!",
                                type: "success"
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFormSubmit(props) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Emissary - Protocol Labs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#4F46E5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Coin Emissary is a tool that streamlines your invoicing workflow, making cryptocurrency transfer management effortless."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "relative shadow-[0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_rgba(0,0,0,0.06)]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (0,tw_merge/* twMerge */.m)("p-4 py-6 lg:py-9 flex items-center", container),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/logo-small.svg",
                            alt: "",
                            width: 34,
                            height: 34,
                            className: "shrink-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden sm:block shrink-0 w-[163px] h-5 relative ml-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/written-logo.svg",
                                alt: "",
                                layout: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "ml-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "flex gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/login",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "rounded-md text-gray-500 px-4 py-2 font-medium block hover:text-indigo-600 duration-200",
                                                children: "Log In"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/signup",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "rounded-md bg-indigo-600 hover:bg-indigo-500 duration-200 text-white px-4 py-2 font-medium block",
                                                children: "Sign Up"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "bg-gray-50 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (0,tw_merge/* twMerge */.m)("flex gap-2 justify-center px-4 pt-16 pb-20 lg:justify-between lg:py-48", container),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-w-xl text-center lg:text-left animate-fadeInUp motion-reduce:animate-none lg:pr-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            className: "text-gray-900 text-3xl lg:text-5xl font-extrabold tracking-tight",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "text-indigo-600 font-extrabold",
                                                    children: "Introducing Emissary"
                                                }),
                                                ":",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Streamline Your Cryptocurrency Transfer Requests"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xl text-gray-500 mt-3 mb-10 lg:mt-5",
                                            children: "Say goodbye to cumbersome cryptocurrency transfer request management. Emissary streamlines your invoicing workflow, making cryptocurrency transfer management effortless."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/signup",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "block rounded-md bg-indigo-600 hover:bg-indigo-500 duration-200 text-white py-3 px-10 font-medium w-full lg:w-fit lg:py-4 lg:text-lg",
                                                children: "Sign Up"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden xl:block flex-shrink-0 overflow-hidden animate-fadeInRight motion-reduce:animate-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "drop-shadow-lg rounded-lg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "rounded-lg",
                                            src: "/dashboard.png",
                                            alt: "Coin Emissary dashboard",
                                            width: 600,
                                            height: 400,
                                            priority: true
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (0,tw_merge/* twMerge */.m)("pt-[4.5rem] pb-24 px-4 flex flex-col lg:px-28 lg:py-24", container),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-10 lg:flex-row lg:flex-wrap lg:justify-center lg:gap-x-8 lg:gap-y-10",
                            children: features.map(function(item) {
                                var Icon = featureIcons[item.icon];
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:max-w-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bg-indigo-500 rounded-md w-12 h-12 flex justify-center items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                width: 24,
                                                color: "white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-lg font-medium leading-6 text-gray-900 mt-5 mb-2",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-gray-500 leading-6",
                                            children: item.description
                                        })
                                    ]
                                }, item.title);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "bg-gray-50 flex flex-col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (0,tw_merge/* twMerge */.m)("px-4 pt-16 pb-6 lg:py-24", container),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "font-extrabold text-4xl leading-9 text-gray-900 tracking-tight",
                                    children: "Express Your Early Interest"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col py-5 lg:flex-row gap-4 lg:gap-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-gray-500 text-lg leading-6 lg:w-2/3",
                                            children: [
                                                "Sign up below to be the first to know about updates and the availability of Emissary for self-hosting.",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Don't let the complexities of managing transfer requests in cryptocurrencies hold you back. Embrace the future of streamlined\n            invoicing with Emissary."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            className: "py-5 lg:w-1/3 flex flex-col lg:flex-row gap-4",
                                            onSubmit: handleSubmit(handleFormSubmit),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* TextInput */.oi, (0,_object_spread/* default */.Z)({
                                                    //@ts-ignore
                                                    id: "userEmail",
                                                    type: "email",
                                                    placeholder: "Enter your email",
                                                    error: errors.email
                                                }, register("email"))),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    type: "submit",
                                                    buttonStyle: "h-10 items-center",
                                                    className: "w-full lg:w-fit shrink-0 lg:my-1",
                                                    loading: isSubmitting,
                                                    disabled: isSubmitting,
                                                    children: "Notify me"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (subscribeObject === null || subscribeObject === void 0 ? void 0 : subscribeObject.message) && subscribeObject.message && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alerts/* PageAlert */.Fw, {
                                    className: "mt-0 lg:mt-5",
                                    type: subscribeObject === null || subscribeObject === void 0 ? void 0 : subscribeObject.type,
                                    children: [
                                        subscribeObject === null || subscribeObject === void 0 ? void 0 : subscribeObject.message,
                                        " "
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: (0,tw_merge/* twMerge */.m)("pt-20 pb-12 flex flex-col gap-9 lg:px-28 lg:py-12 lg:flex-row-reverse lg:justify-between lg:items-center", container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex gap-6 justify-center",
                        children: socialLinks.map(function(item) {
                            var Icon = socialIcons[item.label];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: item.link,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    title: item.label,
                                    className: "p-1 block rounded text-gray-400 hover:text-indigo-600 duration-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: item.label
                                        })
                                    ]
                                })
                            }, item.label);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center text-gray-500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                            children: [
                                "Made with ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-indigo-400",
                                    children: "♥"
                                }),
                                " by",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://protocol.ai/",
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    children: "Protocol Labs"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var featureIcons = {
    lock: esm_LockClosedIcon,
    globe: esm_GlobeAltIcon,
    code: esm_CodeIcon,
    lightning: esm_LightningBoltIcon,
    scale: esm_ScaleIcon
};
var socialIcons = {
    Twitter: components_TwitterIcon,
    Linkedin: components_LinkedinIcon,
    Youtube: components_YoutubeIcon
};


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4444,6949,6232,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);